import { useQuery } from "@tanstack/react-query";
import {
  ChannelFilters,
  ChannelOptions,
  ChannelSort,
  ChannelStateOptions,
  DefaultGenerics,
  StreamChat,
} from "stream-chat";
import { useChatContext } from "stream-chat-react";

interface ExistingChannelParams {
  channelId: string;
  filters?: Omit<ChannelFilters, "id">;
  sort?: ChannelSort;
  options?: ChannelOptions;
  stateOptions?: ChannelStateOptions;
  createOnError?: boolean;
}

/*
 * Uses stream-chat-react to query for a channel based on the given parameters
 * Returns the queried channel if found
 * Will not fire is no stream-client, or no channelId
 */
const useExistingChannel = ({
  channelId,
  filters,
  sort = { last_message_at: -1 },
  options = {
    watch: true,
    state: true,
  },
  stateOptions = undefined,
}: ExistingChannelParams) => {
  const { client } = useChatContext("useExistingChannel") as {
    client: StreamChat<DefaultGenerics>;
  };
  return useQuery({
    queryKey: ["channel", channelId],
    queryFn: async () => {
      return client
        .queryChannels(
          { id: channelId, ...filters },
          sort,
          options,
          stateOptions,
        )
        .then((data) => {
          if (data.length) {
            return data[0];
          }
        });
    },
    enabled: Boolean(client) && Boolean(channelId),
  });
};

export default useExistingChannel;
